import { render, staticRenderFns } from "./HotelModal.vue?vue&type=template&id=5155af60&"
import script from "./HotelModal.vue?vue&type=script&lang=js&"
export * from "./HotelModal.vue?vue&type=script&lang=js&"
import style0 from "./HotelModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports